import { ANGULAR_INIT } from "~/store/action_types";

/** This reducer is useful for storing some data from initial response (session, initial, etc) */
const initial_data = (state = {}, action) => {
  switch (action.type) {
    case ANGULAR_INIT: {
      const { response = {} } = action;
      const { feed_token = "" } = response;
      return {
        ...state,
        feed_token,
      };
    }
    default:
      return state;
  }
};

export default initial_data;
